import { use } from 'react'

import { CloseIcon } from '@chakra-ui/icons'
import { Button, IconButton, Text } from '@chakra-ui/react'

import { useInterview } from '@/react-query/interview/interview'
import { useChangeTranscriptLanguageIsPending } from '@/react-query/transcription/transcription'
import { ButtonDownloadFromFile } from '@/views/components/ButtonDownloadFromFile/ButtonDownloadFromFile'
import { InputTranscriptContext } from '@/views/screens/Interview/components/FullTranscript/context/InputTranscriptContext'

import { InterviewDataContext } from '../../../context'
import { useAudioRecorder } from '../../../context/AudioRecorderContext/AudioRecorderContext'

export const ToolboxFileUploadProgress = () => {
  const { cancelTranscription, isCancellingTranscription } = use(
    InputTranscriptContext,
  )
  const { fileUploadProgress } = use(InterviewDataContext)
  const { isReadOnly, file } = use(InterviewDataContext)

  const { recordedFile } = useAudioRecorder()

  const changeTranscriptLanguageIsPending =
    useChangeTranscriptLanguageIsPending()
  const isFullTranscriptGenerating =
    useInterview().data?.isFullTranscriptGenerating ||
    changeTranscriptLanguageIsPending

  let fileLoadingText: string
  if (isFullTranscriptGenerating || fileUploadProgress === 100) {
    fileLoadingText = 'Transcribing...'
  } else if (fileUploadProgress === 0) {
    fileLoadingText = 'Preparing file...'
  } else {
    fileLoadingText = `Uploading (${fileUploadProgress}%)...`
  }

  return (
    <>
      <Button
        cursor={'pointer'}
        variant={'brand-solid-white'}
        rounded={'1.25rem'}
        isLoading={true}
        disabled={true}
        minW={200}
        loadingText={fileLoadingText}
      />
      <IconButton
        variant={'brand-solid-white'}
        rounded={'full'}
        ml={3}
        aria-label={'Cancel transcription'}
        icon={<CloseIcon />}
        onClick={cancelTranscription}
        isLoading={isCancellingTranscription}
      />
      {recordedFile && (
        <ButtonDownloadFromFile
          file={recordedFile}
          isDisabled={isReadOnly}
          text={'Download recorded meeting'}
          ml={5}
        />
      )}
      <Text ml={5}>
        Usually takes about 5 minutes.{' '}
        {isFullTranscriptGenerating || fileUploadProgress === 100
          ? 'You can now close this tab'
          : 'Please do not close this tab while the file is uploading'}
      </Text>
    </>
  )
}
